<template>
  <button
    v-if="clientId"
    type="button"
    class="google-btn"
    :disabled="loading"
    @click="handleClick"
  >
    <span v-if="loading" class="google-btn-spinner" />
    <svg v-else viewBox="0 0 24 24" class="google-btn-icon" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
    <span>{{ loading ? 'Aguarde...' : label }}</span>
  </button>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  label?: string
  loading?: boolean
}>(), {
  label: 'Continuar com Google',
  loading: false,
})

const emit = defineEmits<{ credential: [value: string] }>()

const config = useRuntimeConfig()
const clientId = config.public.googleClientId as string
const { signInWithGoogle } = useGoogleAuth()
const toast = useToast()

async function handleClick() {
  try {
    const credential = await signInWithGoogle()
    emit('credential', credential)
  } catch (err: any) {
    if (err?.message === 'one_tap_skipped' || err?.message === 'Login cancelado.') return
    const msg = err?.message || String(err)
    console.error('Google sign-in error', err)
    toast.add({ title: 'Falha no login com Google', description: msg, color: 'red' })
  }
}
</script>

<style scoped>
.google-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.625rem 1rem;
  border: 1px solid #dadce0;
  border-radius: 0.5rem;
  background: #fff;
  color: #3c4043;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
}
.google-btn:hover:not(:disabled) {
  background: #f8f9fa;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12);
}
.google-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.google-btn-icon { width: 1.125rem; height: 1.125rem; flex-shrink: 0; }
.google-btn-spinner {
  width: 1.125rem;
  height: 1.125rem;
  border: 2px solid #dadce0;
  border-top-color: #4285F4;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
